import { useQuery } from '@tanstack/react-query';

import { authApi } from '../../lib/authApi';

/**
 * Режим «смотреть от лица» (`authApi.me().viewAs`): менеджер видит страницу партнёра, но отметки только читает —
 * сервер на запись всё равно ответил бы 403. Запрос общий с перепиской помещения (кеш `['wiki-auth','me']`).
 */
export function useViewAsReadOnly(): boolean {
  const me = useQuery({ queryKey: ['wiki-auth', 'me'], queryFn: () => authApi.me(), retry: false, staleTime: 60_000 }).data;
  return Boolean(me?.viewAs);
}
